export const productData = [
	// SORGOS
	{
		title: "Sorgo Forrajero Fotosensitivo Coliqueo",
		type: "Sorgos",
		price: "$4 p/Kg",
		cycle: "Semitardío",
		floweringDays: "100 días",
		averageHeight: "250 cm",
		tanninContent: "Alto",
		grainColor: "Marrón",
		features: [
			"El sorgo híbrido forrajero fotosensitivo está diseñado para no inducirse a la floración por un período muy extenso, gracias a la sensibilidad al fotoperiodo de la línea recuperadora Sudangrass, lo que garantiza un periodo vegetativo más prolongado y una mejor calidad forrajera.",
			"Este sorgo híbrido tiene un rápido rebrote, es folioso y tiene una gran aptitud para pastoreo directo, fardos, rollos, etc.",
			"Cañas finas: Las cañas del sorgo híbrido forrajero fotosensitivo son finas, lo que lo hace fácil de manejar y procesar.",
			"Bajo nivel de HCN: El sorgo híbrido forrajero fotosensitivo tiene un bajo nivel de HCN, lo que lo hace seguro para el consumo animal.",
			"Tiene hojas anchas y brillantes"
		]
	},
	{
		title: "Sorgo Granífero Tucán",
		type: "Sorgos",
		price: "$4 p/Kg",
		cycle: "Semitardío",
		floweringDays: "74 días",
		averageHeight: "160 cm",
		tanninContent: "Alto",
		grainColor: "Marrón",
		aphidTolerance: "Muy Alta",
		features: [
			"Alto rendimiento en grano, ideal para maximizar la producción",
			"Excelente sanidad y resistencia a enfermedades",
			"Panoja semi-compacta con buena capacidad de secado",
			"Planta de altura media con excelente resistencia al vuelco",
			"Adaptabilidad a diferentes zonas productivas",
			"Tolerancia muy alta al pulgón amarillo"
		]
	},
	{
		title: "Sorgo Silero Azucarado Yanquetruz",
		type: "Sorgos",
		price: "$4 p/Kg",
		cycle: "Largo",
		floweringDays: "82 días",
		averageHeight: "250-280 cm",
		tanninContent: "Bajo",
		grainColor: "Marrón",
		features: [
			"Alto contenido de azúcares solubles para mejor calidad de silaje",
			"Excelente producción de materia seca por hectárea",
			"Buena digestibilidad y palatabilidad para el ganado",
			"Tallos jugosos y hojas abundantes",
			"Ideal para sistemas de producción intensiva"
		]
	},
	{
		title: "Sorgo Doble Propósito Santa Ana",
		type: "Sorgos",
		price: "$4 p/Kg",
		cycle: "Medio",
		floweringDays: "70-72 días",
		averageHeight: "170 cm",
		tanninContent: "Alto",
		grainColor: "Marrón",
		aphidTolerance: "Muy Alta",
		features: [
			"Versátil: apto para producción de grano y forraje",
			"Excelente relación grano/planta",
			"Alta capacidad de rebrote post-pastoreo",
			"Buena resistencia a enfermedades foliares",
			"Adaptado a diferentes sistemas de producción",
			"Tolerancia muy alta al pulgón amarillo"
		]
	},
	{
		title: "Sorgo Doble Propósito Santa Lucía",
		type: "Sorgos",
		price: "$4 p/Kg",
		cycle: "Semitardío",
		floweringDays: "77 días",
		averageHeight: "190 cm",
		tanninContent: "Alto",
		grainColor: "Marrón",
		aphidTolerance: "Muy Alta",
		features: [
			"Doble propósito con alto potencial de rendimiento",
			"Ciclo medio a semitardío de 72-75 días a 50% de floración",
			"Alto contenido de taninos condensados en el grano",
			"Altura de planta de 1,80-1,90m con alto volumen de rastrojo",
			"Excelente adaptabilidad a diferentes condiciones ambientales",
			"Tolerancia muy alta al pulgón amarillo"
		]
	},
	
	// SEMILLAS FORRAJERAS
	{
		title: "Festuca Rizomat",
		type: "Semillas Forrajeras",
		price: "Consultar precio",
		biotipo: "Continental",
		features: [
			"Tolerancia a temperaturas y pisoteo",
			"Destacada rusticidad",
			"Rizomas cortos pero notables a partir del segundo año",
			"Ideal para ambientes marginales"
		]
	},
	{
		title: "Ryegrass Perenne Forrajero NUI",
		type: "Semillas Forrajeras",
		price: "Consultar precio",
		characteristics: "Perenne, Diploide",
		features: [
			"Forraje palatable con alta digestibilidad",
			"Pradera densa y duradera",
			"Fuerte macollaje"
		]
	},
	{
		title: "Blend Festuca con Ryegrass Santa Lucía",
		type: "Semillas Forrajeras",
		price: "Consultar precio",
		composition: "85% Festuca Rizomat, 15% Ryegrass Perenne Forrajero",
		features: [
			"Destacada rusticidad",
			"Ideal para manejos ganaderos",
			"Combinación equilibrada de especies"
		]
	},
	{
		title: "Lotus Tenuis",
		type: "Semillas Forrajeras",
		price: "Consultar precio",
		features: [
			"Adaptabilidad a suelos salinos",
			"Alta digestibilidad",
			"Alto contenido protéico",
			"Tolerancia a pastoreos continuos"
		]
	},
	{
		title: "Moha Gigante Colorada",
		type: "Semillas Forrajeras",
		price: "Consultar precio",
		features: [
			"Resistencia a la sequía y altas temperaturas",
			"Aprovechamiento de pastoreo a los 45 días",
			"Ideal para la confección de rollos"
		]
	},
	{
		title: "Avena INTA Sureña",
		type: "Semillas Forrajeras",
		price: "Consultar precio",
		cycle: "Intermedio",
		features: [
			"Alta tolerancia al frío y sequía",
			"Excelente aptitud forrajera y de grano",
			"Resistencia intermedia a la roya de la hoja"
		]
	},
	
	// SEMILLAS ORNAMENTALES
	{
		title: "Ryegrass Perenne Turftype Don Luis",
		type: "Semillas Ornamentales",
		price: "Consultar precio",
		coverage: "1 kg cada 10-20 m²",
		features: [
			"Color verde oscuro",
			"Textura fina",
			"Alta resistencia al pisoteo",
			"Alta densidad de macollos"
		]
	}
];